import styles from 'css/components/classroom/breadcrumb.module.css';
import React from 'react';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  path?: string;
  isActive?: boolean;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <nav className={styles.breadcrumbs} aria-label="Breadcrumb">
      <div className={styles.breadcrumbs__list}>
        {items.map((item, index) => (
          <div key={index} className={styles.breadcrumbs__item}>
            {index === items.length - 1 || item.isActive || !item.path ? (
              <span className={`${styles.breadcrumbs__text} ${styles["breadcrumbs__text--active"]}`}>
                {item.label}
              </span>
            ) : (
              <Link to={item.path} className={styles.breadcrumbs__link}>
                {item.label}
              </Link>
            )}
            {/* mockups separate crumbs with a single right angle quote (U+203A),
                not a greater-than sign */}
            {index < items.length - 1 && (
              <span className={styles.breadcrumbs__separator}>{'\u203A'}</span>
            )}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Breadcrumbs;